
































import { defineComponent, reactive, watch } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import useAuth from '@/useAuth';

import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';

import updateCompany from '@/gql/company/updateCompany.gql';

const CommonFormWithCompanyInformationEditor = defineComponent({
  components: {
    GroupAddressEditor,
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const company = reactive({
      name: '',
      taxId: '',
      contactName: '',
      contactPhone: '',
      address: {
        address: '',
        province: {
          id: '',
        },
        district: {
          id: '',
        },
        subdistrict: {
          id: '',
        },
        textProvince: '',
        textDistrict: '',
        textSubdistrict: '',
        zipcode: '',
      },
    });

    watch(() => me.company.id, (newVal, oldVal) => {
      if (newVal !== -1 && newVal !== oldVal) {
        company.name = me.company.name;
        company.taxId = me.company.taxId;
        company.contactName = me.company.contactName || '';
        company.contactPhone = me.company.contactPhone || '';
        company.address.address = me.company.billingAddress;
        company.address.province.id = me.company.address.province?.id;
        company.address.district.id = me.company.address.district?.id;
        company.address.subdistrict.id = me.company.address.subdistrict?.id;
        company.address.zipcode = me.company.address.zipcode;
      }
    });

    const updateCompanyMutation = useMutation(updateCompany, () => ({
      variables: {
        input: {
          id: me.company.id,
          name: company.name,
          taxId: company.taxId,
          billingAddress: company.address.address,
          contactName: company.contactName,
          contactPhone: company.contactPhone,
          address: {
            address: company.address.address,
            province: company.address.province.id,
            district: company.address.district.id,
            subdistrict: company.address.subdistrict.id,
            zipcode: `${company.address.zipcode}`,
          },
        },
      },
      refetchQueries: ['me', 'getMyInfo'],
    }));
    updateCompanyMutation.onDone(() => { emit('done'); });

    return {
      company,
      updateCompanyMutation,
    };
  },
});

export default CommonFormWithCompanyInformationEditor;
